import { JSX, useState } from "react";
import styles from "./shared.module.scss";
import SkeletonLoader from "./skeleton_loader";
import SortDropdown from "./sortdropdown";
import SingleColumnSelectionMenu from "./single_column_selection_menu";
import React from "react";
import { useTheme } from "@mui/material/styles";
import { Box, Button, Divider, Menu, MenuItem } from "@mui/material";
import { IRegion } from "./types";
import select_col_light from '../../../assets/select_col_light.svg'
import { ArrowBack } from "@mui/icons-material";

interface ListCardProps<T> {
  title: string;
  showFilter?: boolean;
  sortOptions?: { label: string; value: string }[];
  sortBy?: string;
  setSortBy?: (value: string) => void;
  loading: boolean;
  data?: T[];
  columns?: string[];
  showSelectColumns?: boolean;
  onColumnSelection?: (selectedColumn: string) => void;
  renderItem?: (item: T, index: number) => JSX.Element;
  children?: React.ReactNode;
  count?: number;
  loaderStyles?: {
    height?: number;
  };
  headerAction?: React.ReactNode;
  showBreadCrums?: boolean;
  selectedRegion?:any
  breadcrumbLevels?: any;
  onBack?: () => void;
  onLevelSelect?: (index: number) => void;
}

const ListCard = <T,>({
  title,
  showFilter = false,
  sortOptions = [],
  sortBy,
  setSortBy,
  loading,
  data,
  columns = [],
  showSelectColumns = false,
  onColumnSelection,
  renderItem,
  children,
  count = 5,
  loaderStyles,
  headerAction,
  showBreadCrums,
  selectedRegion,
  breadcrumbLevels = [],
  onBack,
  onLevelSelect,  
}: ListCardProps<T>) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  
  const Breadcrumb = ({ selectedRegion, onBack, onLevelSelect, levels }:any) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
  
    const handleClick = (event:any) => {
      setAnchorEl(event.currentTarget);
    };
  
    const handleClose = () => {
      setAnchorEl(null);
    };

    const handleBackClick = (event: React.MouseEvent) => {
      event.stopPropagation();
      event.preventDefault();
      console.log("Back arrow clicked, onBack:", onBack);
      if (onBack) {
        onBack();
      }
    };
  
    return (
      <Box sx={{ display: "flex", alignItems: "center",ml:2 }}>
      
         <ArrowBack className="no-drag clickable-area" sx={{cursor:'pointer'}} onClick={handleBackClick} />
      
         {levels.length > 0 && (
        <Box
          sx={{
            fontWeight: 700,
            cursor: selectedRegion && !selectedRegion.leaf_node ? "pointer" : "default",
            // color: selectedRegion && !selectedRegion.leaf_node ? "primary.main" : "inherit",
            display: "flex",
            alignItems: "center",
            gap: "5px",
            ml: 1,
          }}
        >
          <Box sx={{ display: "flex", flexDirection:"column", alignItems: "left", }}>
          <Box sx={{ display: "flex", flexDirection:"row",gap: "5px"}}>
            <span style={{
              
                maxWidth: "200px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                verticalAlign: "bottom",
                color: isDarkMode ? "#FFFFFF" : "#150F49",
              }}>{selectedRegion?.region_name}</span>
              <span className="no-drag clickable-area">
              ▼
            </span>
          </Box>
            <Box
              sx={{
          display: "flex",
          gap: "5px",
          minWidth: "50px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
              }}
             
            >
              {levels.map((level: any, index: number) => (
          <React.Fragment key={index}>
            {index > 0 && "/"}
            <span
              title={level.region.region_name}
              style={{
                display: "inline-block",
                maxWidth: "200px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                verticalAlign: "bottom",
                color: isDarkMode ? "#C0BFD5" : "#6D738F",
              }}
            >
              {level.region.region_name}
            </span>
          </React.Fragment>
              ))}
            </Box>
          </Box>
        </Box>
           )}
           {levels.length === 0 && (
            <Box sx={{ fontWeight: 700,ml: 1 }}>
            <span style={{
                display: "inline-block",
                maxWidth: "100px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                verticalAlign: "bottom",
                color: isDarkMode ? "#FFFFFF" : "#150F49",
              }}>{selectedRegion?.region_name}</span>
          </Box>
           )}

        {/* <Button onClick={handleClick} sx={{ ml: 1 }}>
              ▼
            </Button> */}
        {/* {levels.length > 1 && (
          <>
            <Button onClick={handleClick} sx={{ ml: 1 }}>
              ▼
            </Button>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
              {levels.map((level:any, index:any) => (
                <MenuItem
                  key={index}
                  onClick={() => {
                    handleClose();
                    onLevelSelect(index);
                  }}
                >
                  {level?.region_name}
                </MenuItem>
              ))}
            </Menu>
          </>
        )} */}
      </Box>
    );
  };
  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  return (
    <div data-theme={theme.palette.mode}>
      <div className={styles.container}>
        <div className={styles.header} style={{height: "45px"}}>
          <h2>{title}</h2> 
          <div style={{ display: 'flex', gap: '10px' }}>
            {headerAction || (showFilter && sortBy && setSortBy && (
              <SortDropdown
                sortBy={sortBy}
                setSortBy={setSortBy}
                options={sortOptions}
              />
            ))}
             {showSelectColumns && (
             <Button
                onClick={handleMenuClick}
                size="small"
                disableRipple
                disableFocusRipple
                sx={{
                  minWidth: 'auto',
                  padding: 0,
                  background: 'none',
                  boxShadow: 'none',
                  border: 'none',
                  '&:hover': {
                    background: 'none',
                    boxShadow: 'none',
                    cursor: 'pointer',
                  },
                  '&:active': {
                    background: 'none',
                    boxShadow: 'none',
                  },
                  // position: 'absolute',
                  // right: 0,
                  // top: 0,
                }}
              >
                <img src={select_col_light} alt="select_col_light" style={{ display: 'block' }} />
              </Button>
            )}
          </div>
        </div>
        {/* <div style={{ margin: "18px 0px" }}></div> */}
        {/* <Divider sx={{ boxShadow: "8px 8px #0000000D" }}></Divider> */}
       <div className={styles.data_container}>
        {showBreadCrums && (
         <div style={{ background: isDarkMode ? "#393E4B" : "#F1F1F7", height: "50px", maxHeight: "50px",display: "flex", alignItems: "center", }}>
          <Breadcrumb
            selectedRegion={selectedRegion}
            onBack={onBack}
            onLevelSelect={onLevelSelect}
            levels={breadcrumbLevels}
          />
          </div>
             )}
            <div
              className={`${styles.data_container_padding} scroll`}
              style={{
              height: showBreadCrums ? "225px" : "275px",
              maxHeight: showBreadCrums ? "225px" : "275px",
              marginTop: showBreadCrums ? "8px" : "8px",
              }}
            >
              {loading ? (
              <SkeletonLoader count={count} styles={loaderStyles} />
              ) : children ? (
              children
              ) : data && renderItem ? (
              <>
                {data.map((item, index) => (
                <React.Fragment key={index}>
                  {renderItem(item, index)}
                </React.Fragment>
                ))}
              </>
              ) : null}
            </div>
       </div>
      </div>
      {showSelectColumns && (
        <SingleColumnSelectionMenu
          anchorEl={menuAnchorEl}
          open={Boolean(menuAnchorEl)}
          onClose={handleMenuClose}
          columns={columns}
          onApply={onColumnSelection || (() => {})}
        />
      )}
    </div>
  );
};

export default ListCard;
